var LAYOUT = {
  desktopNavbarHeight: '75px',
  mobileNavbarHeight: '60px',
  backNavbarHeight: '70px'
};

export { LAYOUT as default };
